import type { JobTemplateBrief } from '@recruitee/job-templates-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<JobTemplateBrief>()(
  'JobTemplates',
  {
    customActions: adapter => ({
      upsertOne: (state, payload: { data: JobTemplateBrief }) =>
        adapter.upsertOne(state, payload.data),
    }),
  },
);

export {
  actions as JobTemplatesActions,
  namespace as JobTemplatesNamespace,
  reducer as JobTemplatesReducer,
  selectors as JobTemplatesSelectors,
};
